import * as React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { useCartLoadingImage } from 'hooks/use-cart-loading-image';

import {
  Container,
  GraphicTextWrapper,
  LoadingGraphic,
  LoadingGraphicWrapper,
  LoadingText,
  StyledModalHeader,
} from './checking-availability.styled';

const messages = defineMessages({
  checkingDeliveryAvailability: {
    id: 'checkingDeliveryAvailability',
    defaultMessage: 'Checking Delivery Availability',
    description: 'Checking Delivery Availability modal header',
  },

  checkingDeliveryAvailabilityText: {
    id: 'checkingDeliveryAvailabilityText',
    defaultMessage:
      'We are checking which restaurant will service your address. This may take a few moments.',
    description: 'Checking Delivery Availability modal description',
  },
});
/**
 *
 * CheckingAvailability shows a loader when checking if guest address is deliverable
 *
 */
const CheckingAvailability: React.FC = () => {
  const { formatMessage } = useIntl();
  const { src } = useCartLoadingImage();
  return (
    <Container data-testid="cart-loading">
      <StyledModalHeader>{formatMessage(messages.checkingDeliveryAvailability)}</StyledModalHeader>
      <GraphicTextWrapper>
        <LoadingGraphicWrapper data-testid="checking-delivery-availability">
          {src && (
            <LoadingGraphic alt={formatMessage(messages.checkingDeliveryAvailability)} src={src} />
          )}
        </LoadingGraphicWrapper>
        <LoadingText>{formatMessage(messages.checkingDeliveryAvailabilityText)}</LoadingText>
      </GraphicTextWrapper>
    </Container>
  );
};

export default CheckingAvailability;
